import { Spinner } from '@catapultsports/referee-react';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/16px/chevron-right.svg';
import clsx from 'clsx';
import { useTranslations } from 'i18n';
import mixpanel from 'mixpanel-browser';
import * as React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { Link, useRouteMatch } from 'react-router-dom';
import styles from './settings-menu.module.css';
import { useSettingsMenuItems } from './use-settings-menu-items';
interface SettingsMenuProps {
    activePage: string;
}

export const SettingsMenu: React.FunctionComponent<SettingsMenuProps> = (props) => {
    const { activePage } = props;
    const menuItems = useSettingsMenuItems();
    const { __ } = useTranslations();
    const { url } = useRouteMatch();

    const trackMenuSelected = (id?: string) => () => {
        mixpanel.track('SettingsMenuSelected', {
            selected_menu_name: id,
        });
    };

    return (
        <div className={styles['settings-menu__container']}>
            <div className={styles['settings-menu__header']}>
                <h2>{__('misc.settings')}</h2>
            </div>
            <div className={styles['settings-menu__items']}>
                <Scrollbars autoHide={true}>
                    {menuItems.length ? (
                        menuItems.map((menuItem, key) => {
                            const { id, label, hasDivider = false } = menuItem;
                            return (
                                <div
                                    key={key}
                                    className={clsx({
                                        [styles['settings-menu__item']]: true,
                                        [styles['settings-menu__item--selected']]: id === activePage,
                                    })}
                                >
                                    {hasDivider && <hr />}
                                    {label && (
                                        <Link to={`${url}/${id}`} title={label} onClick={trackMenuSelected(id)}>
                                            <span>{label}</span>
                                            <div className={styles['settings-menu__item-arrow']}>
                                                <ChevronRightIcon />
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            );
                        })
                    ) : (
                        <div className={styles['settings-menu__item--loading']}>
                            <Spinner variant="muted" />
                        </div>
                    )}
                </Scrollbars>
            </div>
        </div>
    );
};
